var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198.574,
    height: 200,
    viewBox: "0 0 198.574 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 138.176,
    y: 93.736,
    width: 47.876,
    height: 81.04,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 93.822,
    y: 36.176,
    width: 51.464,
    height: 138.594,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 53.314,
    y: 36.282,
    width: 51.229,
    height: 138.487,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 108.104,
    y: 39.667,
    width: 56.778,
    height: 135.106,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 33.709,
    y: 39.656,
    width: 56.771,
    height: 135.119,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 66.481,
    y: 4.053,
    width: 65.638,
    height: 65.569,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 81.923,
    y: 100.419,
    width: 34.76,
    height: 74.348,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 12.522,
    y: 93.732,
    width: 47.895,
    height: 81.041,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.614)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.614)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.287,
    cy: 100,
    rx: 99.287,
    ry: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.287,
    cy: 100,
    rx: 97.287,
    ry: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.908 19.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35.651-357.646a2.417,2.417,0,0,1-2.295,1.014,2.273,2.273,0,0,1-1.811-3.305c1.432-3.069,2.963-6.091,4.57-9.071a2.223,2.223,0,0,1,3.921.049c1.574,2.95,3.046,5.956,4.5,8.972a2.177,2.177,0,0,1-.619,2.861,2.294,2.294,0,0,1-3.013-.135c-.122-.1-.244-.188-.385-.3a1.956,1.956,0,0,0-.145,1.222q-.01,15.488-.007,30.979c0,1.646,0,1.646,1.7,1.649,1.551,0,3.1-.02,4.652.01a2.246,2.246,0,0,1,2.459,2.3,2.151,2.151,0,0,1-2.436,2.269q-4.287.025-8.574,0a2.086,2.086,0,0,1-2.387-2.055,15.588,15.588,0,0,1-.125-2.074q-.01-15.917,0-31.838Z",
    transform: "translate(193.18 478.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-53.147-382.983a19.257,19.257,0,0,0,3.53-2.364c3-3.164,6.552-2.463,9.976-1.4A11.344,11.344,0,0,1-31.7-375.677q.039,24.926,0,49.851a6.925,6.925,0,0,1-7.161,7.072c-1.554,0-3.108.072-4.656-.023-1.175-.069-1.432.405-1.429,1.488q.044,16.476.02,32.948c0,.938.023,1.88-.013,2.818a2.245,2.245,0,0,1-2.288,2.473,2.262,2.262,0,0,1-2.427-2.344c-.036-.365-.023-.734-.023-1.1q0-29.761,0-59.528a7.72,7.72,0,0,1,.082-1.462,2.384,2.384,0,0,1,2.331-1.965,2.377,2.377,0,0,1,2.242,1.926,7.409,7.409,0,0,1,.092,1.459q0,8.455,0,16.9c0,1.666,0,1.669,1.715,1.673,1.472,0,2.94.02,4.412-.01A2.182,2.182,0,0,0-36.5-325.69c.023-.24.016-.487.016-.734q0-24.431,0-48.87a7.1,7.1,0,0,0-5.383-7.266,11.755,11.755,0,0,0-2.8-.158c-2.693-.023-5.39-.029-8.083-.049C-52.828-382.769-52.894-382.841-53.147-382.983Z",
    transform: "translate(161.97 438.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.272-383.09a1.766,1.766,0,0,1-1.406.283c-2.733.02-5.469-.017-8.2.023a6.733,6.733,0,0,0-6.842,6.838q-.049,24.921-.013,49.842c0,1.847.665,2.5,2.519,2.528,1.551.03,3.1-.036,4.652.026,1.027.04,1.337-.356,1.33-1.356-.033-5.759-.016-11.514-.013-17.269,0-2.183.813-3.335,2.348-3.352,1.508-.013,2.4,1.208,2.4,3.339q0,29.943,0,59.883c0,2.16-.764,3.164-2.361,3.18a2.154,2.154,0,0,1-2.341-2.008,10.347,10.347,0,0,1-.046-1.465q0-17.271,0-34.538c0-1.689,0-1.689-1.669-1.692-1.551,0-3.1.006-4.656,0a6.9,6.9,0,0,1-6.9-6.826c-.049-3.632-.013-7.266-.013-10.9q0-19.473,0-38.943A11.609,11.609,0,0,1-54.17-387.531c.2-.013.412,0,.612-.017a5.993,5.993,0,0,1,5.419,1.752A23.982,23.982,0,0,0-44.272-383.09Z",
    transform: "translate(133.82 438.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.119-373.935c-.435.277-.629.421-.843.53a2.3,2.3,0,0,1-2.733-.313,2.046,2.046,0,0,1-.589-2.555c1.465-3.052,2.93-6.108,4.534-9.087a2.32,2.32,0,0,1,4.116.056c1.544,2.921,2.986,5.9,4.422,8.877a2.122,2.122,0,0,1-.6,2.756c-.988.813-2.048.708-3.569-.4v88.334a4.771,4.771,0,0,1-.474,2.607A3.208,3.208,0,0,1-29.8-281.48c-5.512,0-11.023.01-16.531,0a2.231,2.231,0,0,1-2.4-2.226A2.281,2.281,0,0,1-46.4-286.04c2.98-.043,5.959-.016,8.939-.02,1.715,0,3.431-.036,5.143.013.925.03,1.271-.346,1.2-1.225-.026-.283,0-.57,0-.856v-85.808Z",
    transform: "translate(171.83 441.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-62.171-373.852a2.337,2.337,0,0,0-.181,1.389q-.01,42.3,0,84.613c0,1.794,0,1.8,1.831,1.8H-48.28c.365,0,.734-.01,1.1.006a2.374,2.374,0,0,1,2.41,2.4,2.23,2.23,0,0,1-2.466,2.163c-5.143.02-10.286.01-15.429.01-.369,0-.734.006-1.1-.007a3.278,3.278,0,0,1-3.309-3.24c-.03-.53-.013-1.06-.013-1.59v-87.754c-.352.26-.56.444-.8.583a2.28,2.28,0,0,1-2.743-.148,2.053,2.053,0,0,1-.688-2.631c1.472-3.092,2.96-6.183,4.583-9.2a2.284,2.284,0,0,1,3.974.056c1.613,2.976,3.085,6.028,4.547,9.084a2.113,2.113,0,0,1-.629,2.657C-59.744-372.894-60.788-372.954-62.171-373.852Z",
    transform: "translate(120.25 441.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-43.612-397.633a17.845,17.845,0,0,1,17.773,17.782,17.968,17.968,0,0,1-17.829,17.786A17.884,17.884,0,0,1-61.477-380.1,17.826,17.826,0,0,1-43.612-397.633Zm-.063,4.708A12.933,12.933,0,0,0-56.723-380a13.015,13.015,0,0,0,13.058,13.2A13.071,13.071,0,0,0-30.59-379.758,13,13,0,0,0-43.675-392.925Z",
    transform: "translate(142.96 416.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-52.03-345.866q0,9.606-.007,19.211c0,1.88-.777,2.831-2.265,2.871a2.187,2.187,0,0,1-2.413-1.932,8.344,8.344,0,0,1-.066-1.465q0-18.723,0-37.446c0-.369-.013-.737.016-1.1a2.45,2.45,0,0,1,2.315-2.4,2.454,2.454,0,0,1,2.407,2.436c.03.409.016.817.016,1.225Z",
    transform: "translate(153.71 483.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.52, -19.05)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-68.833-357.453a7.243,7.243,0,0,1-1.231.711,2.273,2.273,0,0,1-2.479-.593,2.124,2.124,0,0,1-.428-2.5c1.482-3.088,2.986-6.173,4.6-9.2a2.216,2.216,0,0,1,3.862,0c1.613,2.977,3.118,6.015,4.583,9.068A2.206,2.206,0,0,1-60.6-357.1a2.292,2.292,0,0,1-3.009-.185c-.118-.092-.247-.175-.392-.28a2.464,2.464,0,0,0-.142,1.36q-.015,16.969-.007,33.932c0,2.591-.57,3.151-3.174,3.151-2.571,0-5.143.007-7.718,0-1.617-.006-2.483-.77-2.519-2.183a2.218,2.218,0,0,1,2.476-2.387c1.758-.03,3.513-.023,5.268,0,.675.007,1.077-.145,1.077-.941q-.035-16.352-.036-32.7C-68.771-357.377-68.807-357.41-68.833-357.453Z",
    transform: "translate(105.08 478.89)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/Growth.4dc9cc24ece675e48e925e3ab2bedb4e.svg";
export { ForwardRef as ReactComponent };